# Existing league calendar; component and week are selected locally.
query PackageAnnualScheduleCell($scenarioId: ID!, $originId: ID!, $resourceId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    editorView(resourceType: LINK, resourceId: $resourceId) {
      sections {
        id
        component {
          id
          code
          name
        }
        sessions {
          id
          events {
            id
            interval {
              id
            }
            block {
              id
              day
              startingTime
              endingTime
            }
          }
          instructors {
            id
            code
            name
            hasAccess
          }
          classrooms {
            id
            code
            name
            building {
              id
              code
              name
            }
          }
        }
      }
    }
  }
}
